import { render, staticRenderFns } from "./MyStaffReviewForm.vue?vue&type=template&id=613b8e2e&scoped=true"
import script from "./MyStaffReviewForm.vue?vue&type=script&lang=js"
export * from "./MyStaffReviewForm.vue?vue&type=script&lang=js"
import style0 from "./MyStaffReviewForm.vue?vue&type=style&index=0&id=613b8e2e&prod&lang=css"
import style1 from "./MyStaffReviewForm.vue?vue&type=style&index=1&id=613b8e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613b8e2e",
  null
  
)

export default component.exports